import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import md5 from 'js-md5';

Vue.config.productionTip = false
Vue.prototype.$md5 = md5;

import '../src/assets/css/reset.css'
import '../src/assets/css/style.css'
import '../src/assets/css/flex.css'
// import '../src/assets/css/loginregist.css'
import 'lib-flexible/flexible'
import Vant from 'vant';
import 'vant/lib/index.css';

// import echarts from 'echarts'  //引入echarts
// Vue.prototype.$echarts = echarts  //挂载在全局
Vue.use(Vant);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
